import { useContext, useMemo } from 'react';
import { getTicketNumberDetectionAccess } from 'shared/lib/authUtils';
import { PermissionContext } from './PermissionProvider';

/**
 * useTicketNumberDetectionAccess — reactive unique ticket-number detection
 * ("Deteksi Unik Nomor Tiket") access for the Permission Access Layer (SA-1851).
 *
 * Reads `company` from the reactive PermissionContext projection and derives the
 * flag from `ticket_number_setting`, which rides inside the same `company` blob
 * that `applyPermissionsFromMe` rewrites on login and on token refresh — so no
 * new watched storage key was needed. Mirrors `useTamperDetectionAccess`.
 *
 * @returns {{ isTicketNumberDetectionActive: boolean }}
 */
export const useTicketNumberDetectionAccess = () => {
  const { company } = useContext(PermissionContext);

  return useMemo(
    () => getTicketNumberDetectionAccess(company?.ticket_number_setting),
    [company]
  );
};
